import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import type { JackpotIconType } from '../../@types';
import { mergeSx } from '../../utils/styles';

type Props = {
  type: JackpotIconType;
  size: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
};

const sizeMap = {
  small: 16,
  medium: 30,
  large: 80,
};

const COIN_IMAGE_BY_TYPE: Record<JackpotIconType, string> = {
  bronze: '/images/casino/jackpot/tiers/bronze.webp',
  silver: '/images/casino/jackpot/tiers/silver.webp',
  gold: '/images/casino/jackpot/tiers/gold.webp',
  platinum: '/images/casino/jackpot/tiers/platinum.webp',
  diamond: '/images/casino/jackpot/tiers/diamond.webp',
};

const JackpotIcon = ({ type = 'bronze', size = 'small', sx }: Props) => (
  <Box
    component='img'
    src={COIN_IMAGE_BY_TYPE[type]}
    alt={`${type} jackpot coin`}
    sx={mergeSx({ display: 'block', width: sizeMap[size], height: sizeMap[size] }, sx)}
    data-testid={`jackpot-${type}-icon`}
  />
);

export default JackpotIcon;
